import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

const DeleteModal = ({ distributeStore }) => {
    const {
        deleteModalVisisble, closeDeleteModal, deleteCampaign, deleteModalItem, deleteModalData,
    } = distributeStore

    return (
        <Modal
            show={deleteModalVisisble}
            onClose={closeDeleteModal}
        >
            <div className="delete-modal-content">
                <i className="fal fa-circle-exclamation" style={{ fontSize: 36, color: 'red' }} />

                <h2>{deleteModalData.title}</h2>

                <p>{deleteModalData.body}</p>
            </div>

            <ModalFooter>
                <div className="delete-modal-footer-content">
                    <Button cssClass="regular tertiary" onClick={closeDeleteModal}>
                        {i18n.t('gen_no')}
                    </Button>

                    <Button cssClass="regular error" onClick={() => deleteCampaign([deleteModalItem])}>
                        <i className="fal fa-circle-xmark" style={{ marginRight: 5 }} />

                        {i18n.t('settings_delete_delete_link')}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default observer(DeleteModal)
